define('lib/Podio.Transport.SpaceInvitations.Profiles',['require','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function getProfilesByIds(ids, callback) {
    var path = routes.ids_contacts_for_checklist_path(ids.join(','));    
    transport.getJSON(path, { abortable: true }, function(responseData) {
      if (responseData.status === 'ok') {
        callback(responseData.data);
      }
    });
  }

  return {
    getProfilesByIds: getProfilesByIds
  };
});
